const {logger} = require('./utils')

let context

const TED = 1236 // Tracking-Event Definitions
const CXF_TRACK_MSG = 'cxf.tracking.message'

const ANNOUNCEMENT_READY = `announcement_ready`
const OPEN_ANNOUNCEMENTS = `click`
const DONT_SHOW_AGAIN_ACTIVATE = `dont_show_again_activate`
const DONT_SHOW_AGAIN_DEACTIVATE = `dont_show_again_deactivate`
const CLOSE_CROSS = `close_cross`
const CLOSE_REGULAR = `close_regular`
const SCROLL = `scroll`
const LOADED = `loaded`

const init = (contextInst) => {
    logger.log('tracking has been initialized', contextInst)

    context = contextInst
}

const getAnnouncement = (announcements) => {
    let result
    if (announcements) {
        result = Array.isArray(announcements.Items)
            ? announcements.Items[0]
            : announcements
    }

    return result
}

const tracking = (actionType, announcements, parameters) => {
    const announcementData = getAnnouncement(announcements)
    let payload = {
        eventId: TED,
        gameId: Number.parseInt(context.gameId, 10),
        networkId: Number.parseInt(context.networkId, 10),
        instanceId: context.instanceId,
        playerId: context.playerId,
        language: context.countryCode,
        date: new Date().toUTCString(),
        zoneId: context.zoneId,
        actionType
    }

    const {
        id,
        start_date: startDate,
        end_date: endDate,
        title: name
    } = announcementData

    payload = {...payload, ...parameters}

    payload.id = id
    payload.scheduleStart = new Date(startDate).toUTCString()
    payload.scheduleEnd = new Date(endDate).toUTCString()
    payload.name = name

    logger.log(CXF_TRACK_MSG, JSON.stringify(payload, null, 4))
    context.emit(CXF_TRACK_MSG, payload)
}

module.exports = {
    init,
    tracking,
    OPEN_ANNOUNCEMENTS,
    ANNOUNCEMENT_READY,
    CLOSE_CROSS,
    CLOSE_REGULAR,
    DONT_SHOW_AGAIN_ACTIVATE,
    DONT_SHOW_AGAIN_DEACTIVATE,
    SCROLL,
    LOADED
}
